import { render, staticRenderFns } from "./dyPacsList_D.vue?vue&type=template&id=519cb3a4&scoped=true"
import script from "./dyPacsList_D.vue?vue&type=script&lang=js"
export * from "./dyPacsList_D.vue?vue&type=script&lang=js"
import style0 from "./dyPacsList_D.vue?vue&type=style&index=0&id=519cb3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519cb3a4",
  null
  
)

export default component.exports